import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useI18next } from "gatsby-plugin-react-i18next";
import React, { useState } from "react";
import useQuotePath from "../blue-library/hooks/useQuotePath";
import Layout from "../corporate-site/layout";
import { checkSMSOTP, resetPassword, sendSMSOTP } from "../qnb/api/login";
import { saveQuoteToUser } from "../qnb/api/quotation";
import OTP from "../qnb/components/Popup/Login/otp";
import OtpButton from "../qnb/components/Popup/Login/otpButton";
import ResetPassword from "../qnb/components/Popup/Login/resetPassword";
import { loadTencentCaptcha } from "../shared/utils/tencent_captcha";
import store from "../store/store";
export var forgetPasswordSource = "forget-password";
var Verify = function Verify() {
    var _useState = useState("otpB"), dialog = _useState[0], setDialog = _useState[1]; // const [tokenId, setTokenId] = useState("");
    // useEffect(() => {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   setTokenId(urlParams.get("tokenID") as string);
    // }, []);
    var _useState2 = useState(""), pwErrorCode = _useState2[0], setPwErrorCode = _useState2[1];
    var _useState3 = useState(""), otpErrorCode = _useState3[0], setOtpErrorCode = _useState3[1];
    var _useState4 = useState(""), otpBErrorCode = _useState4[0], setOtpBErrorCode = _useState4[1];
    var originalPath = useQuotePath();
    var i18n = useI18next();
    var onSubmitOTP = /*#__PURE__*/ function () { var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(otpValue) { var res; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
        switch (_context.prev = _context.next) {
            case 0:
                _context.next = 2;
                return checkSMSOTP({ otpCode: otpValue ? otpValue.join("") : "", sendType: "1", referUrl: originalPath });
            case 2:
                res = _context.sent;
                if (!res.errorCode && res.result === true) {
                    setDialog("pw");
                }
                else {
                    setOtpErrorCode(res.errorCode);
                }
            case 4:
            case "end": return _context.stop();
        }
    } }, _callee); })); return function onSubmitOTP(_x) { return _ref.apply(this, arguments); }; }();
    var onSubmitResetPW = /*#__PURE__*/ function () { var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(password) { var res, state, qnb, qnbProduct; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
        switch (_context2.prev = _context2.next) {
            case 0:
                _context2.next = 2;
                return resetPassword({ password: password });
            case 2:
                res = _context2.sent;
                if (!(!res.errorCode && res.result === true)) {
                    _context2.next = 13;
                    break;
                }
                state = store.getState();
                qnb = state.qnb;
                qnbProduct = state.qnbProduct;
                if (!(qnbProduct.quoteInfo.geQuoteMain.eid && qnb.quotationNumber)) {
                    _context2.next = 10;
                    break;
                }
                _context2.next = 10;
                return saveQuoteToUser({ productCode: qnbProduct.quoteInfo.geQuoteMain.eid, quoteNo: qnb.quotationNumber });
            case 10:
                store.dispatch({ type: "ui/setDialogOpen", payload: { status: true, page: "changedPassword", onDialogClose: function onDialogClose() { var _res$data$referUrl; i18n.navigate((_res$data$referUrl = res.data.referUrl) !== null && _res$data$referUrl !== void 0 ? _res$data$referUrl : "/"); } } });
                _context2.next = 14;
                break;
            case 13: setPwErrorCode(res.errorCode);
            case 14:
            case "end": return _context2.stop();
        }
    } }, _callee2); })); return function onSubmitResetPW(_x2) { return _ref2.apply(this, arguments); }; }(); //發送驗證碼
    var _useState5 = useState(false), otpBDisabled = _useState5[0], setOtpBDisabled = _useState5[1];
    var _useI18next = useI18next(), language = _useI18next.language;
    var sendOTP = /*#__PURE__*/ function () { var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3() { var data, res; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
        switch (_context3.prev = _context3.next) {
            case 0:
                setOtpBDisabled(true);
                _context3.next = 3;
                return loadTencentCaptcha(language);
            case 3:
                data = _context3.sent;
                if (!(data && Object.keys(data).length !== 0)) {
                    _context3.next = 11;
                    break;
                }
                _context3.next = 7;
                return sendSMSOTP(data.ticket, data.randstr);
            case 7:
                res = _context3.sent;
                if (res && !res.errorCode && res.result === true) {
                    setOtpBDisabled(false);
                    setDialog("otp");
                }
                else {
                    setOtpBDisabled(false);
                    setOtpBErrorCode(res === null || res === void 0 ? void 0 : res.errorCode);
                }
                _context3.next = 13;
                break;
            case 11:
                setOtpBDisabled(false);
                setOtpBErrorCode("-612");
            case 13:
            case "end": return _context3.stop();
        }
    } }, _callee3); })); return function sendOTP() { return _ref3.apply(this, arguments); }; }();
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", { className: "bg-msg-1 py-10 lg:py-24 px-4 lg:px-10" }, dialog === "pw" && /*#__PURE__*/ React.createElement(ResetPassword, { onSubmit: onSubmitResetPW, extErrorCode: pwErrorCode }), dialog === "otp" && /*#__PURE__*/ React.createElement(OTP, { onSubmit: onSubmitOTP, extErrorCode: otpErrorCode, source: forgetPasswordSource, apiType: "FPN" }), dialog === "otpB" && /*#__PURE__*/ React.createElement(OtpButton, { onSubmit: sendOTP, extErrorCode: otpBErrorCode, disabled: otpBDisabled })));
};
export default Verify;
var query = "3698718234";
